module.exports = __webpack_public_path__ + "static/giraffecomforterrattle-26dd10de138e22a3bec1b6b85782c1e6.jpeg";